import { styled } from '@mui/material/styles';

export const LineThrough = styled('span')(({ theme }) => ({
    textDecorationLine: 'line-through',
    color: theme.colors.text.tertiary,
}));
